export default {
  create: 'Create maintenance task',
  edit: 'Edit maintenance task',
  taskName: 'Task name',
};
